import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/metaPixel";

// Fires a Meta Pixel PageView on every SPA route change.
// The very first PageView is already fired by the base script in index.html,
// so we skip the initial render to avoid double-counting.
const MetaPixelRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!window.__flvPixelInitialFired) {
      window.__flvPixelInitialFired = true;
      return;
    }
    trackPageView();
  }, [location.pathname, location.search]);

  return null;
};

export default MetaPixelRouteTracker;
